import { useQuery } from "@tanstack/react-query";

import { FeatureTypeDefinition, getRanaApiV1 } from "@nens/rana/api-v1";

// STAT

export type FeatureTypeStylingOptions = {
  [key in FeatureTypeDefinition]: { style_id: string };
};

const getStyleByFeature = () => {
  return getRanaApiV1().getQueryOptions<FeatureTypeStylingOptions>({
    queryKey: ["feature-type-style-id"],
    queryFn: async () => {
      return getRanaApiV1().StylesApi.listFeatureTypeStyles(
        {}
      ) as Promise<FeatureTypeStylingOptions>;
    },
  });
};

export const useGetStyleByFeature = () => {
  return useQuery(getStyleByFeature());
};
